/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionStartPageMask';

const ActionStartPageMaskManager: ActionManagerFn<'ActionStartPageMask'> = (
  platform: Platform,
): ActionManager<'ActionStartPageMask'> => {
  return {
    ...baseActionManager(platform, 'ActionStartPageMask'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Start Page Mask',
    icon: { iconName: 'spinner', iconType: 'duotone' },
    description: `**Overview**<br/>
The Start Page Mask action is a functional component designed to initiate a visual masking state on the user interface. It signals the application to block user interaction or indicate processing status by overlaying a mask on the page.<br/><br/>
This component is lightweight, leveraging the platform's base action infrastructure without defining additional custom properties or complex logic within the manager itself. It identifies itself visually in the registry with a duotone spinner icon.

**Key Features**<br/>
* **Standard Inheritance:** Built directly upon baseActionManager and baseActionProps, ensuring seamless integration with the standard action lifecycle and property structure.
* **Simplified Configuration:** Unlike mapping components, it does not enforce custom property visibility rules or validation logic, relying on the default behavior of the base action system.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps, indicating it accepts the standard set of configuration options common to all actions in the system, with no component-specific fields defined in this manager.

**Use Cases**<br/>
* **UI Feedback:** Explicitly configured to "start page masking," typically used to prevent user input or show a loading indicator during long-running operations.`,
  };
};

export default ActionStartPageMaskManager;
